import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { ButtonComponent, IconComponent } from '@mode/capra';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AcknowledgeForm, DialogHeaderComponent } from '@mode/shared/ui';
import { take } from 'rxjs/operators';
import { EnhancedDatasetResult, FeatureFlag, ProducerType, ProducerTypes } from '@mode/shared/contract-common';
import { getInitialFlagValue } from '@mode/shared/util-js';
import { Observable } from 'rxjs';
import { SwitchViewFacade } from '@mode/switch-views/contract';

@Component({
  selector: 'mode-unpublish-dataset-dialog',
  standalone: true,
  imports: [CommonModule, ButtonComponent, DialogHeaderComponent, FormsModule, ReactiveFormsModule, IconComponent],
  templateUrl: './unpublish-dataset-dialog.component.html',
  styleUrls: ['./unpublish-dataset-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnpublishDatasetDialogComponent {
  notebookDatasetPublishUpdatesEnabled = getInitialFlagValue(FeatureFlag.NotebookDatasetPublishUpdates);
  enhancedDatasetResult$!: Observable<EnhancedDatasetResult | undefined>;
  switchViewToken: string;
  @Output() unpublish = new EventEmitter<{
    datasetToken: string;
    producerType: ProducerType;
    switchViewToken: string;
    datasetThoughtspotPublicationToken: string;
  }>();

  readonly form = new AcknowledgeForm();

  constructor(
    protected dialogRef: MatLegacyDialogRef<UnpublishDatasetDialogComponent>,
    private switchViewFacade: SwitchViewFacade,
    @Inject(MAT_LEGACY_DIALOG_DATA)
    private data: {
      switchViewToken: string;
    }
  ) {
    this.switchViewToken = this.data.switchViewToken;
  }

  unpublishDataset(): void {
    this.enhancedDatasetResult$ = this.switchViewFacade.getEnhancedDataseResult(this.switchViewToken);
    this.enhancedDatasetResult$.pipe(take(1)).subscribe({
      next: (dataset) => {
        this.unpublish.emit({
          datasetToken: dataset?.datasetToken ?? '',
          producerType: dataset?.producerType ?? ProducerTypes.SqlQuery,
          switchViewToken: this.switchViewToken,
          datasetThoughtspotPublicationToken: dataset?.thoughtspot?.datasetThoughtspotPublicationToken ?? '',
        });
      },
    });

    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
